var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckMeBackInput',{attrs:{"customer":_vm.customer,"topup":_vm.instrument.id,"transfer":_vm.instrument.settlement_amount/100,"arrears":_vm.instrument.arrears}})
}
var staticRenderFns = []

export { render, staticRenderFns }